export default __webpack_public_path__ + "static/media/3.047ea235.jpg";